<template>
  <div class="formData payment_record">
    <FormBox :title="$t('message.DataRegistration.Taxi.record')">
      <template slot="right">
        <el-button type="primary" plain @click="$router.push('/taxi')">{{
          $t("message.back")
        }}</el-button>
      </template>
      <el-table :data="showAll ? data : data.slice(0, 5)" v-loading="loading">
        <!-- 年度 -->
        <el-table-column
          :label="$t('message.DataRegistration.Taxi.year')"
          prop="year"
        ></el-table-column>
        <!-- 查詢編號 -->
        <el-table-column
          :label="$t('message.DataRegistration.Taxi.spNo')"
          prop="applicationNo"
        ></el-table-column>
        <!-- 繳付總額 -->
        <el-table-column
          :label="$t('message.DataRegistration.Taxi.total')"
          prop="amount"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.amount == 0 ? "-" : scope.row.amount }}</span>
          </template>
        </el-table-column>
        <!-- 繳付方式中文 -->
        <el-table-column
          v-if="$i18n.locale == 'ZH_TW' || $i18n.locale == 'ZH_CN'"
          :label="$t('message.DataRegistration.Taxi.payment')"
          prop="payWayCn"
        ></el-table-column>
        <!-- 繳付方式葡文 -->
        <el-table-column
          v-if="$i18n.locale == 'PT' || $i18n.locale == 'EN'"
          :label="$t('message.DataRegistration.Taxi.payment')"
          prop="payWayPt"
        ></el-table-column>
        <!-- 繳付日期 -->
        <el-table-column
          :label="$t('message.DataRegistration.Taxi.payment_date')"
          prop="paymentDate"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.paymentDate | formatDT("dd/MM/yyyy") }}</span>
          </template>
        </el-table-column>
      </el-table>
    </FormBox>
    <div v-if="!showAll && data.length > 5" class="showMore">
      <span @click="showAllData">{{
        $t("message.DataRegistration.Taxi.showAll")
      }}</span>
    </div>
  </div>
</template>

<script>
import FormBox from "../components/FormBox";
import TaxiApplicationAPI from "../../../../api/TaxiApplicationAPI";
export default {
  components: { FormBox },
  data() {
    return {
      loading: false,
      showAll: false,
      data: [],
    };
  },
  methods: {
    showAllData() {
      this.showAll = true;
    },
    get() {
      const serviceType = this.$store.state.serviceType;
      const verifyForm = this.$store.state.verifyForm;
      const identType = "BM";
      const identNo = verifyForm.identityNo;
      this.loading = true;
      TaxiApplicationAPI.history(serviceType, identType, identNo)
        .then((res) => {
          this.loading = false;
          this.data = res;
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
  },
  created() {
    this.get();
  },
};
</script>

<style lang="scss" scoped>
.formData {
  overflow: hidden;
  max-width: 1048px;
  margin: auto;
  box-shadow: 0px 2px 7px 2px rgba(0, 0, 0, 0.16);
}
.payment_record {
  min-height: 800px;
  /deep/.el-table {
    margin: 30px 0;
    table {
      min-width: 530px;
      width: 100% !important;
    }
  }
  /deep/.el-table th {
    background: #5ba7ad;
    color: #fff;
    font-size: 16px;
    text-align: center;
  }

  /deep/.el-table--enable-row-transition .el-table__body td {
    text-align: center;
    font-size: 16px;
  }
}
.showMore {
  text-align: center;
}
.showMore span {
  display: inline-block;
  color: #5ba7ad;
  font-size: 18px;
  padding: 10px;
  border-top: 1px solid #5ba7ad;
  cursor: pointer;
}
</style>